import userServiceFactory from '#/notes/api/userServiceFactory'

const getters = {
  userService: ({environment}, _, rootState) => userServiceFactory(environment, rootState.authentication)
}

export default getters
